import classNames from 'classnames';

const TabBarTab = ({ tab, isActive }) => {

  return (
    <div
      data-tip="React-tooltip"
      data-for={`TabBarTab${tab.name}`}
      aria-current={isActive ? "page" : undefined}
      className={classNames(
        isActive ? "text-gray-900" : "text-gray-500 hover:text-gray-700"
      )}
    >
      <span>{tab.name}</span>
      <span
        aria-hidden="true"
        className={classNames(
          isActive ? "bg-rose-500" : "bg-transparent",
          "absolute inset-x-0 bottom-0 h-0.5"
        )}
      />
    </div>
  );
};

export default TabBarTab;
